import { render, staticRenderFns } from "./EmbedExtensionModal.vue?vue&type=template&id=27605fc2&scoped=true&"
import script from "./EmbedExtensionModal.vue?vue&type=script&lang=js&"
export * from "./EmbedExtensionModal.vue?vue&type=script&lang=js&"
import style0 from "./EmbedExtensionModal.vue?vue&type=style&index=0&id=27605fc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27605fc2",
  null
  
)

export default component.exports